import * as yup from "yup";

const validation = (errors) => {
  return yup.object().shape({});
};

export default validation;
